module.exports = __webpack_public_path__ + "static/media/2122-service-1-3-min.8b20f436.jpg";